var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"entrypoint"},[_c('form',{staticClass:"dropzone",attrs:{"action":_vm.url,"name":"dropzone","id":_vm.id,"numMaxArquivos":_vm.numMaxArquivos}})])}
var staticRenderFns = []

export { render, staticRenderFns }